import { useState } from 'react';
import DialogBase from './DialogBase';
import { nameValidationMessage } from '../staging';
import NameSelector from '../selectors/NameSelector';

const CreateEntity = ({ usedNames, submit, onExit, children }) => {
  const [newEquipmentValidation, setNewEquipmentValidation] = useState(nameValidationMessage(''));
  return (
    <DialogBase open id="create" disabled={newEquipmentValidation} onExit={onExit} submit={submit}>
      <NameSelector
        usedNames={usedNames}
        onError={(message) => setNewEquipmentValidation(message)}
      />
      {children}
    </DialogBase>
  );
};

export default CreateEntity;
